import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAndroid } from "@fortawesome/free-brands-svg-icons";

import Wrapper from "../../../shared/components/layout/Wrapper";
import Header from "../../../shared/components/layout/Header";
import Footer from "../../../shared/components/layout/Footer";
import SEO from "../../../shared/components/layout/SEO";
import ButtonLinkHref from "../../../shared/components/elements/ButtonLinkHref";
import Picture1 from "../../../assets/images/picture1.png";
import { useLanguage } from "../../../context/LanguageProvider";

const Home = () => {
    const { t } = useLanguage();

    // Both download buttons are identical, so they are rendered from data
    const downloadLinks = [
        { url: t.home.downloadUrlBazaar, label: t.home.downloadBazaar },
        { url: t.home.downloadUrlMyket, label: t.home.downloadMyket }
    ];

    return (
        <>
            <SEO title={t.seo.home.title} description={t.seo.home.description} />
            <Header />

            <main className="min-h-screen">
                <section className="relative flex my-10 md:my-16">
                    <Wrapper>
                        <div className="relative z-10 text-light-primary">
                            <div className="w-1/2 lg:w-1/6 md:w-1/4 m-auto flex justify-center items-center relative">
                                <img
                                    src={Picture1}
                                    alt="teenage boy coding on phone using codepro app"
                                    className="w-full"
                                />
                            </div>

                            <h1 className="text-3xl text-center lg:text-4xl mt-10 md:mt-12 xl:text-5xl flex justify-center w-full font-bold leading-relaxed drop-shadow">
                                {t.home.heading}
                            </h1>

                            <p className="mt-8 md:mt-10 flex justify-center text-center text-2xl lg:text-lg drop-shadow">
                                {t.home.subtitle}
                            </p>

                            <div className="w-full mt-12 md:mt-10 gap-y-5 md:gap-x-8 flex flex-col md:flex-row justify-center">
                                {downloadLinks.map(({ url, label }) => (
                                    <ButtonLinkHref
                                        key={url}
                                        to={url}
                                        openInNewTab
                                        className="gap-x-2 w-full md:w-fit"
                                    >
                                        <span>{label}</span>
                                        <FontAwesomeIcon icon={faAndroid} />
                                    </ButtonLinkHref>
                                ))}
                            </div>
                        </div>
                    </Wrapper>
                </section>
            </main>

            <Footer />
        </>
    );
};

export default Home;